import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import "./assets/css/elan-tokens.css";
import "./assets/css/theme.css";
import "./assets/css/magazine-theme.css";
import "./assets/css/workspace-ui.css";
import feedback from "./services/feedback";

const app = createApp(App);
app.use(router);
app.use(store);
app.config.globalProperties.$feedback = feedback;
app.config.globalProperties.$message = feedback;
app.config.globalProperties.$confirm = feedback.confirm;

const resizeObserverLoopErrRe = /^[^(]*ResizeObserver/i;
const resizeObserverLoopErrHandler = (event) => {
  if (!resizeObserverLoopErrRe.test(event.message)) return;
  event.stopImmediatePropagation();
  event.preventDefault();
};
const resizeObserverLoopRejHandler = (event) => {
  if (!event.reason || !resizeObserverLoopErrRe.test(event.reason.message || event.reason)) return;
  event.preventDefault();
};

window.addEventListener("error", resizeObserverLoopErrHandler, true);
window.addEventListener("unhandledrejection", resizeObserverLoopRejHandler, true);

app.mount("#app");
